export const resources = {
  AppSettingsSaveSuccessfully: ''
};
